import type { ApiErrorBody, ApiValidationError } from './types';
import { isApiErrorBody } from './types';

export function createApiError(
  message: string,
  body: unknown
): ApiValidationError {
  const err = new Error(message) as ApiValidationError;
  if (isApiErrorBody(body)) {
    err.errorCode = body.errorCode ?? undefined;
    err.errorDetails = body.errorDetails ?? null;
  } else {
    err.errorCode = undefined;
    err.errorDetails = null;
  }
  return err;
}

export function createApiErrorFromCaught(
  caught: unknown,
  fallbackMessage: string
): ApiValidationError | null {
  const body =
    typeof caught === 'object' &&
    caught !== null &&
    'body' in caught &&
    (caught as { body: unknown }).body !== undefined
      ? (caught as { body: unknown }).body
      : null;

  if (body === null || body === undefined) {
    return null;
  }

  const message = isApiErrorBody(body)
    ? (body.errorText ? String(body.errorText) : null)
    : null;
  const err = createApiError(
    message || (caught instanceof Error ? caught.message : fallbackMessage),
    body
  );
  if (
    typeof caught === 'object' &&
    caught !== null &&
    'status' in caught &&
    typeof (caught as { status: number }).status === 'number' &&
    err.errorCode === undefined
  ) {
    err.errorCode = (caught as { status: number }).status;
  }
  return err;
}
